export default __webpack_public_path__ + "static/media/warning-image.765f84cf.svg";